import React, { useContext } from "react";
import "./Who_we_are.css";
import { Context } from "../../../utils/context";

function Who_we_are() {
  const { language } = useContext(Context);
  return (
    <>
      <section className="Who_we_are">
        <div className="container">
          <div className="text_holder">
            <>
              <h2>{language == 1 ? "Who We Are" : "Qui nous sommes"}</h2>

              <p>
                {language == 1
                  ? "We’re a passionate team in India with a global partner network, helping students access authentic internships and study programs abroad."
                  : "Nous sommes une équipe passionnée basée en Inde avec un réseau mondial de partenaires, aidant les étudiants à accéder à des stages et des programmes d’études authentiques à l’étranger."}
              </p>
            </>

            <div className="quote_img_holder quote_img_1">
              <img
                src="/assets/images/home/who_we_are/img_1.webp"
                alt="quote 1"
                className=" quote_img "
              />
            </div>

            <div className="quote_img_holder quote_img_2">
              <img
                src="/assets/images/home/who_we_are/img_2.webp"
                alt="quote 2"
                className=" quote_img "
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Who_we_are;
